/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InlineObjectDto } from '../models';
/**
 * PracticalExamActivityReportApi - axios parameter creator
 * @export
 */
export const PracticalExamActivityReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a human-readable PDF report describing the activity around a single practical (Stage 3) exam: participant and exam metadata, commission composition, result, every examinee/commission access (entries), anti-cheat security events (COPY/PASTE/PRINT_SCREEN) and the chronological changelog of commission actions. 
         * @summary Get practical exam activity report (PDF)
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPracticalExamActivityReport: async (certificationId: number, stageId: number, examId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getPracticalExamActivityReport', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getPracticalExamActivityReport', 'stageId', stageId)
            // verify required parameter 'examId' is not null or undefined
            assertParamExists('getPracticalExamActivityReport', 'examId', examId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/exams/{examId}/activity-report`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"examId"}}`, encodeURIComponent(String(examId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PracticalExamActivityReportApi - functional programming interface
 * @export
 */
export const PracticalExamActivityReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PracticalExamActivityReportApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a human-readable PDF report describing the activity around a single practical (Stage 3) exam: participant and exam metadata, commission composition, result, every examinee/commission access (entries), anti-cheat security events (COPY/PASTE/PRINT_SCREEN) and the chronological changelog of commission actions. 
         * @summary Get practical exam activity report (PDF)
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPracticalExamActivityReport(certificationId: number, stageId: number, examId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPracticalExamActivityReport(certificationId, stageId, examId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamActivityReportApi.getPracticalExamActivityReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PracticalExamActivityReportApi - factory interface
 * @export
 */
export const PracticalExamActivityReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PracticalExamActivityReportApiFp(configuration)
    return {
        /**
         * Returns a human-readable PDF report describing the activity around a single practical (Stage 3) exam: participant and exam metadata, commission composition, result, every examinee/commission access (entries), anti-cheat security events (COPY/PASTE/PRINT_SCREEN) and the chronological changelog of commission actions. 
         * @summary Get practical exam activity report (PDF)
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPracticalExamActivityReport(certificationId: number, stageId: number, examId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getPracticalExamActivityReport(certificationId, stageId, examId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PracticalExamActivityReportApi - interface
 * @export
 * @interface PracticalExamActivityReportApi
 */
export interface PracticalExamActivityReportApiInterface {
    /**
     * Returns a human-readable PDF report describing the activity around a single practical (Stage 3) exam: participant and exam metadata, commission composition, result, every examinee/commission access (entries), anti-cheat security events (COPY/PASTE/PRINT_SCREEN) and the chronological changelog of commission actions. 
     * @summary Get practical exam activity report (PDF)
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamActivityReportApiInterface
     */
    getPracticalExamActivityReport(certificationId: number, stageId: number, examId: string, options?: RawAxiosRequestConfig): AxiosPromise<File>;

}

/**
 * PracticalExamActivityReportApi - object-oriented interface
 * @export
 * @class PracticalExamActivityReportApi
 * @extends {BaseAPI}
 */
export class PracticalExamActivityReportApi extends BaseAPI implements PracticalExamActivityReportApiInterface {
    /**
     * Returns a human-readable PDF report describing the activity around a single practical (Stage 3) exam: participant and exam metadata, commission composition, result, every examinee/commission access (entries), anti-cheat security events (COPY/PASTE/PRINT_SCREEN) and the chronological changelog of commission actions. 
     * @summary Get practical exam activity report (PDF)
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamActivityReportApi
     */
    public getPracticalExamActivityReport(certificationId: number, stageId: number, examId: string, options?: RawAxiosRequestConfig) {
        return PracticalExamActivityReportApiFp(this.configuration).getPracticalExamActivityReport(certificationId, stageId, examId, options).then((request) => request(this.axios, this.basePath));
    }
}

